import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useService } from '~/services/service.base';
import { WrapperService } from '~/services/service.wrapper';

export const Promotional: FC = observer(() => {
    const wrapperService = useService(WrapperService);
    const { promotionsService } = wrapperService;

    return (
        <section className="promotional" id="promotional">
            <div className="container">
                {promotionsService.promotions.map((promotion, index) => (
                    <div className="promotional-wrap" key={index}>
                        <div className="promotional-txt-wrap">
                            <h2>{promotion.title}</h2>
                            <p>{promotion.text}</p>
                            <div className="promotional-btn-wrap pbw-desktop">
                                <button type="button" className="btn" onClick={() => window.open(promotion.btnLink)}>
                                    Play
                                </button>
                            </div>
                        </div>
                        <div className="promotional-img-wrap">
                            <figure>
                                <img src={promotion.image} />
                            </figure>
                            <div className="promotional-btn-wrap pbw-mobile">
                                <button type="button" className="btn" onClick={() => window.open(promotion.btnLink)}>
                                    Play
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
});
